import { useDarkModeCheck, useTheme } from "@/contexts/RADashboardThemeContext/hooks"
import { LayoutEditorProps } from "@/interfaces/raDashboard.interface"
import { Box, ThemeProvider, createTheme as createMuiTheme } from '@mui/material'
import React, { useEffect, useState } from "react"
import DashboardGuiCanvas from "./DashboardGuiCanvas"
import DashboardGuiPalette from "./DashboardGuiPalette"
import DashboardGuiTabs from "./DashboardGuiTabs"

const DashboardGuiEditor: React.FC<LayoutEditorProps> = (props) => {
  const theme = useTheme()
  const isDarkMode = useDarkModeCheck()
  const [selectedTab, setSelectedTab] = useState<string | null>(null)

  useEffect(() => {
    if (!selectedTab && props.layout) {
      setSelectedTab(props.layout.initialTab ?? props.layout.tabsOrder?.[0] ?? null)
    }
  }, [props.layout?.tabsOrder])

  const selectedTabExists = selectedTab != null && props.layout?.tabLayouts?.[selectedTab] != null

  const muiTheme = createMuiTheme({
    typography: { fontFamily: theme.fontFamily },
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      background: { paper: theme.cardBackground },
      text: { primary: theme.textPrimary, secondary: theme.textSecondary },
      divider: theme.border,
    },
  })

  return (
    <ThemeProvider theme={muiTheme}>
      <Box sx={{ display: 'flex', gap: 1, mt: 3, minHeight: 400 }}>
        <DashboardGuiTabs layout={props.layout} isLocked={props.isLocked} setLayout={props.setLayout} selectedTab={selectedTab} onSelectTab={setSelectedTab} />
        {selectedTabExists && <DashboardGuiCanvas layout={props.layout} isLocked={props.isLocked} setLayout={props.setLayout} selectedTab={selectedTab} />}
        {selectedTabExists && <DashboardGuiPalette layout={props.layout!} isLocked={props.isLocked} setLayout={props.setLayout} selectedTab={selectedTab!} dashboardType={props.dashboardType} />}
      </Box>
    </ThemeProvider>
  )
}

export default DashboardGuiEditor
